import React, { useEffect } from "react";
import "./style.scss";
import { AiOutlineShoppingCart } from "react-icons/ai";
import { Dialog } from "@material-ui/core";
import { LAST_TRANSACTION } from "../../app/api/apiRoutes";
import { purchase } from "../../app/ga4/gaMethods";
import useApiRequest from "../../utils/hooks/useApiRequest";
// import { TransitionProps } from "@material-ui/core/transitions";
// import Slide from "@material-ui/core/Slide";

interface IProps {
  open: boolean;
  afterOpenModal?: () => void;
  closeModal: () => void;
}

// const Transition = React.forwardRef(function Transition(
//   props: TransitionProps & { children?: React.ReactElement<any, any> },
//   ref: React.Ref<unknown>
// ) {
//   return <Slide direction="up" ref={ref} {...props} />;
// });

const PaymentSuccesModal: React.FC<IProps> = ({ open, closeModal }: IProps) => {
  const { get } = useApiRequest();

  const getLastTransaction = async () => {
    const { result, isError } = await get(LAST_TRANSACTION);
    if (!isError) {
      purchase(result.transactionInfo, result.value, result.lines);
    }
  };

  useEffect(() => {
    getLastTransaction();
  });

  return (
    <Dialog
      // TransitionComponent={Transition}
      fullScreen={false}
      maxWidth={"md"}
      open={open}
      keepMounted
      onClose={closeModal}
      aria-labelledby="alert-dialog-slide-title"
      aria-describedby="alert-dialog-slide-description"
    >
      <div className={"payment-success-modal-container"}>
        <div className="sukces">
          <div className="circle">
            <AiOutlineShoppingCart className="icon"></AiOutlineShoppingCart>
          </div>

          <div className="text">
            <h1>Transakcja przebiegła pomyślnie</h1>

            <p className="description-light">
              Dziękujemy za zakup w naszym sklepie. Twoje bilety zaraz do Ciebie dotrą.
            </p>

            <div className="buttons">
              <button onClick={closeModal} className="button">
                Świetnie, zamknij okno
              </button>
            </div>
          </div>
        </div>
      </div>
    </Dialog>
  );
};

export default PaymentSuccesModal;
